import { useState } from "react";
import { useTranslation } from "react-i18next";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { updateSubscriptions } from "../../services/AdminServices";
import { FaBell, FaUser, FaEnvelope, FaMap, FaLanguage } from "react-icons/fa";
import { REGIONS, LANGUAGES, ETHNICITY_OPTIONS } from "../common/Constants"
import { useEffect } from "react";

export default function SubscriptionForm() {
  const { t, i18n } = useTranslation("labels");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [ethnicity, setEthnicity] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [language, setLanguage] = useState(i18n.language || "en");

  useEffect(() => {
    //console.log("Language" , language);
    //console.log("Updating subscription form language to", i18n.language);
    setLanguage(i18n.language || "en");
        //console.log("Language" , language);
  }, [i18n.language]);


  const handleSubmit = async (e) => {
    const subscriptions = {
      firstName,
      lastName,
      phone,
      ethnicity,
      email,
      regions: selectedRegions,
      lang: language,
      createdAt: new Date().toISOString(),
      status: "active",
      unSubscribeURL: `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`,
    };
    console.log("Submitting subscription form", subscriptions);

    e.preventDefault();

    if (!UtilMethods.validateEmail(email)) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (selectedRegions.length === 0) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (!firstName || !lastName) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else { setStatus(null); }


    try {
      await updateSubscriptions(subscriptions);
      subscriptions.unSubscribeURL = `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`;
     // sendEmail(subscriptions);
      console.log("Subscription form updated successfully");
    } catch (error) {
      console.error("Error updating subscription form", error);
      setStatus("error");
      setErrorMessage(t("subscription.apiError"));
    }

    setStatus("success");
    setFirstName("");
    setLastName("");
    setPhone("");
    setEthnicity("");
    setEmail("");
    setSelectedRegions([]);
  };

  return (
    <section className="mrc-wrapper">
      <div className="mrc-left">
        <h1 >{t("subscription.title")}</h1>
        <p>{t("subscription.subtitle")}</p>
      </div>

      <form className="mrc-form" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <div className="input-with-icon" style={{ flex: 1 }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <input
              placeholder={t("subscription.firstName")}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="input-with-icon" style={{ flex: 1 }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <input
              placeholder={t("subscription.lastName")}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="input-with-icon">
          <span className="input-icon">
            <FaEnvelope />
          </span>
          <input
            placeholder={t("subscription.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <div className="input-with-icon" style={{ flex: 1 }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <select
              value={ethnicity}
              onChange={(e) => setEthnicity(e.target.value)}
            >
              {ETHNICITY_OPTIONS.map((eth) => (
                <option key={eth.value} value={eth.value}>
                  {eth.label}
                </option>
              ))}
            </select>
          </div>
          <div className="input-with-icon" style={{ flex: 1 }}>
            <span className="input-icon">
              <FaLanguage />
            </span>
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              {LANGUAGES.map((lang) => (
                <option key={lang.value} value={lang.value}>
                  {lang.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="region-box">


          <div className="region-options">
            <span className="input-icon">
              <FaMap />
              {" "}{t("subscription.region")}</span>
            {/*
            <label>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) =>
                  setSelectedRegions(e.target.checked ? REGIONS : [])
                }
              />
              {t("subscription.all")}
            </label>
*/ }
            {REGIONS.map((r) => (
              <label key={r.value}>
                <input
                  type="checkbox"
                  checked={selectedRegions.includes(r.value)}
                  onChange={(e) =>
                    setSelectedRegions((s) =>
                      e.target.checked
                        ? [...s, r.value]
                        : s.filter((x) => x !== r.value)
                    )
                  }
                />
                {r.label}
              </label>
            ))}
          </div>
        </div>

        <button type="submit" className="subscribe-btn">
          <FaBell />
          <span>{t("subscription.send")}</span>
        </button>


        {status === "success" && (
          <p className="success">{t("subscription.success")}</p>
        )}
        {status === "error" && (
          <p className="error">{errorMessage}</p>
        )}
      </form>
    </section>
  );
}
